// extracted by mini-css-extract-plugin
export default {"scroll":"VendorStoreManage_scroll__H08mt","success":"VendorStoreManage_success__DlxrK","error":"VendorStoreManage_error__+SM7+","border":"VendorStoreManage_border__WE0z6"};